/**
 * Role definitions matching backend contracts
 */

/**
 * Global roles (cross-organization)
 */
export const GlobalRole = {
  User: 'user',
  Admin: 'kirin_admin',
} as const;

export type GlobalRole = (typeof GlobalRole)[keyof typeof GlobalRole];

/**
 * Organization roles
 */
export const OrganizationRole = {
  Owner: 'owner',
  Manager: 'manager',
  Member: 'member',
  Support: 'support',
} as const;

export type OrganizationRole =
  (typeof OrganizationRole)[keyof typeof OrganizationRole];

/**
 * Named role combinations — frontend mirror of the backend `roleGroups`
 * (apps/backend/src/lib/rbac.ts + routes/organizations/org-auth-configs.ts).
 * Read-scope checks use `managerOwnerOrSupport`/`anyRole`; write-capability
 * checks use `managerOrOwner`/`ownerOnly`. Keep in sync with the backend.
 */
export const roleGroups = {
  ownerOnly: [OrganizationRole.Owner],
  managerOrOwner: [OrganizationRole.Owner, OrganizationRole.Manager],
  ownerOrSupport: [OrganizationRole.Owner, OrganizationRole.Support],
  managerOwnerOrSupport: [
    OrganizationRole.Owner,
    OrganizationRole.Manager,
    OrganizationRole.Support,
  ],
  anyMember: [
    OrganizationRole.Member,
    OrganizationRole.Manager,
    OrganizationRole.Owner,
  ],
  anyRole: [
    OrganizationRole.Member,
    OrganizationRole.Manager,
    OrganizationRole.Owner,
    OrganizationRole.Support,
  ],
} as const satisfies Record<string, readonly OrganizationRole[]>;
